import { render, staticRenderFns } from "./createCurrencyExchange.vue?vue&type=template&id=88d131d6"
import script from "./createCurrencyExchange.vue?vue&type=script&lang=js"
export * from "./createCurrencyExchange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports